import Error404 from './Error404.vue'
export default Error404